import { type FC } from 'react';

import type { InterfaceService } from '@/types';

import InterfaceSubServiceStatus from '@/components/interface-status/interface-sub-service-status';
import useBreakpoint from '@/hooks/use-break-point';
import { cn } from '@/lib/utils';

interface InterfaceServiceRowProps {
  service: InterfaceService;
  id: string;
}

const InterfaceServiceRow: FC<InterfaceServiceRowProps> = ({ service, id }) => {
  const { services } = service;

  const isTablet = useBreakpoint('tablet');

  const hasSubServices = services.length > 0;
  const hasMultipleSubServices = services.length > 1;

  return (
    <div
      className={cn('flex items-start justify-between gap-4 py-2', {
        'border-b': !hasMultipleSubServices && id !== 'core',
        'pt-0.5': !hasMultipleSubServices && !hasSubServices,
      })}
    >
      <div className="w-full">
        <div className="flex justify-between">
          <InterfaceSubServiceStatus
            service={service}
            hasMultipleSubServices
            isShowLastSync={!hasMultipleSubServices}
          />
        </div>
        {hasSubServices && (
          <div className="ml-5 flex flex-col">
            {services.map((subService) => (
              <div
                className={cn('py-2 w-full', {
                  'border-b': hasMultipleSubServices && !isTablet,
                  'py-1': isTablet,
                })}
              >
                <InterfaceSubServiceStatus
                  service={subService}
                  hasMultipleSubServices={hasMultipleSubServices}
                  isShowLastSync={hasMultipleSubServices}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default InterfaceServiceRow;
